import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var SettingsIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M12 8c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm8.3 1.4c.1-.3.4-.4.7-.4 1.7 0 3-1.3 3-3s-1.3-3-3-3h-.2c-.2 0-.4-.1-.5-.3 0-.1 0-.2-.1-.2-.1-.2-.1-.5.1-.6l.1-.1c1.2-1.2 1.2-3 0-4.2-1.1-1.2-3.1-1.1-4.2 0l-.1.1c-.2.2-.5.3-.7.2 0 0-.1 0-.1-.1-.2-.2-.3-.4-.3-.7V3c0-1.7-1.3-3-3-3S9 1.3 9 3v.2c0 .2-.1.4-.3.5-.1 0-.2 0-.2.1-.2.1-.5 0-.7-.2h-.1c-1.2-1.2-3-1.2-4.2 0-1.2 1.2-1.2 3 0 4.2l.1.1c.2.2.3.5.2.7 0 .1 0 .1-.1.2-.2.2-.4.3-.6.3H3c-1.7 0-3 1.3-3 3s1.3 3 3 3h.2c.2 0 .5.2.6.4.1.2.1.5-.1.6l-.1.1c-1.2 1.2-1.2 3 0 4.2 1.2 1.2 3 1.2 4.2 0l.1-.1c.2-.2.5-.3.7-.2.1 0 .1.1.2.1.2.3.3.5.3.8 0 1.7 1.3 3 3 3s3-1.3 3-3v-.2c0-.2.2-.5.4-.6.2-.1.5-.1.6.1l.1.1c1.2 1.2 3 1.2 4.2 0 1.2-1.2 1.2-3 0-4.2l-.1-.1c0-.2-.1-.5 0-.7zm-1.8-.8c-.4.9-.3 2 .4 2.9 0 0 0 .1.1.1l.1.1c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0l-.1-.1c-.8-.8-2-1-3-.5-.9.5-1.6 1.4-1.6 2.4v.1c0 .6-.4 1-1 1s-1-.4-1-1.1c0-1.1-.7-2.1-1.7-2.4-.9-.4-1.9-.2-2.8.5 0 0-.1 0-.1.1l-.1.1c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l.1-.1c.8-.8 1-2 .5-3-.5-.9-1.4-1.6-2.4-1.6H3c-.6 0-1-.4-1-1s.4-1 1-1h.1c1.1 0 2.1-.7 2.4-1.7.4-.9.2-1.9-.5-2.8 0 0 0-.1-.1-.1v-.1c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l.1.1.1.1c.8.6 1.8.8 2.6.5.1 0 .2 0 .3-.1 1-.5 1.6-1.4 1.6-2.4V3c0-.6.4-1 1-1s1 .4 1 1v.1c0 1.1.6 2.1 1.6 2.4.9.4 2 .2 2.8-.4 0 0 .1 0 .1-.1l.1-.1c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-.1.1c-.7.7-1 1.8-.6 2.7 0 .1 0 .2.1.3.5.9 1.4 1.6 2.4 1.6h.2c.6 0 1 .4 1 1s-.4 1-1.1 1c-1 0-1.9.6-2.4 1.6z"
                        }),
                        _jsxs("g", {
                            fillRule: "evenodd",
                            children: [
                                _jsx("use", {}),
                                _jsx("use", {
                                    fillRule: "nonzero"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
SettingsIcon.isCarinaIcon = true;
export default SettingsIcon;
